import * as yup from 'yup'

export const schema = () => yup.object().shape({
    payment: yup.string()
        .required('El campo es requerido'),
    terms: yup.boolean()
        .isTrue()
})